import { buildFilterQuery } from '@/libs/utils.js'
import TranslationProvider from '@/provider/translations.js'
import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'

export const attr_gec_suppliers = 'gec.suppliers'
export const attr_gec_subject_vat = 'gec.subject.vat'
export const attr_subject_fiscal_codes= 'gec.subject.fiscal_codes'

export const getCompiledPoll = async (compiledPollId) => {
  try {
    let url = `/compiled-poll/api/compiled-poll/${compiledPollId}?poll=1`
    const response = await client.get(url)
    return response.data
  } catch (error) {
    throw error
  }
}

export const getCompiledPolls = async (
  page = 1,
  filters = '',
  campaignType = '',
  campaignId = ''
) => {
  try {
    let url = `/compiled-poll/api/compiled-poll?page=${page}&orderBy=updatedAt&orderDir=DESC&campaign_data=1`

    if (campaignId) {
      url += `&campaign=${campaignId}`
    }

    if (filters) {
      url += filters
    }

    if (campaignType) {
      url += `&campaign_type=${campaignType}`
    }

    return await client.get(url)
  } catch (error) {
  }
}

export const getFromAttributeAndString = async (params = {}) => {
  let url = `/compiled-poll/api/compiled-poll/search-attribute`

  const query = buildFilterQuery(params)
  if (query) {
    url += `?${query}`
  }

  return await client.get(url)
}
